import { render, staticRenderFns } from "./userDetailVip.vue?vue&type=template&id=65f135f8&scoped=true"
import script from "./userDetailVip.vue?vue&type=script&lang=js"
export * from "./userDetailVip.vue?vue&type=script&lang=js"
import style0 from "./userDetailVip.vue?vue&type=style&index=0&id=65f135f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f135f8",
  null
  
)

export default component.exports